// Copyright (c) 2019 Deere & Company

import actions from '../actions-list';

export const updateIncludeFullyComplete = includeFullyComplete => ({
    includeFullyComplete,
    type: actions.UPDATE_OPEN_PIP_PROGRAMS_REPORT_INCLUDE_FULLY_COMPLETE
});



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/action-creators/update-include-fully-complete.js